__turbopack_context__.v({
  "grid__lead": "Cards-module__sY8Zuq__grid__lead",
});
